import "../components/CPagination.css";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import { PAGINATION_OPTIONS } from "../utils/Constant";
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';

const CPagination = ({
  storeCHMDashboardData,
  storeCHMPaginationData,
  changePaginationLimit,
  prevPage,
  nextPage,
  paginationLimitOptions,
  showTotalCount = true,
  showHelper = false,
  helperText
}: any) => {
  const { limit, offset, selectedLimit } = storeCHMPaginationData;
  const limitOptions = paginationLimitOptions || PAGINATION_OPTIONS.DEFAULT;

  const isMobile = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  };

  return (
    <div className="footer">
      <p style={{ fontWeight: "600", fontSize: "14px", margin: "0", color: "#5C79AA" }}>
        {isMobile() ? "Records:" : "No. of Records:"}
        {storeCHMDashboardData.count > limit
          ? limit
          : storeCHMDashboardData.count}
        {showTotalCount && `/${storeCHMDashboardData.count}`}
        {showHelper &&
          <Tooltip
            title={helperText}
            placement="right-end"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: 'black',
                  fontSize: '12px'
                }
              }
            }}
          >
            <InfoTwoToneIcon className="label-icon-date-picker"/>
          </Tooltip>
        }
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: isMobile() ? 'column' : 'row',
        }}
      >
        <FormControl>
          <RadioGroup
            row
            value={selectedLimit}
            onChange={(event: any) => {
              changePaginationLimit(Number(event.target.value));
            }}
          >
            {limitOptions.map((limitOption: any) => (
              <FormControlLabel
                key={limitOption}
                value={parseInt(limitOption)}
                control={
                  <Radio
                    size="small"
                    sx={{
                      color: "#5C79AA",
                      "&.Mui-checked": {
                        color: "#5C79AA",
                      },
                    }}
                  />
                }
                label={limitOption}
                sx={{ color: "#5C79AA" }}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <label style={{ fontWeight: "550", fontSize: "14px", color: "#5C79AA" }}>
            Pagination :
          </label>
          <img
            src={require("../assets/img/prev.png")}
            alt=""
            style={{ 
              cursor: "pointer", 
              marginRight: "5px", 
              marginLeft: "5px",
              filter: "brightness(0) saturate(100%) invert(31%) sepia(15%) saturate(1234%) hue-rotate(189deg) brightness(95%) contrast(89%)"
            }}
            onClick={() => {
              prevPage(limit);
            }}
          />

          <label style={{ fontWeight: "550", fontSize: "14px", color: "#5C79AA" }}>
            {offset} - {offset + selectedLimit}
          </label>
          <img
            src={require("../assets/img/next.svg").default}
            alt=""
            style={{ 
              cursor: "pointer", 
              marginRight: "5px", 
              marginLeft: "5px",
              filter: "brightness(0) saturate(100%) invert(31%) sepia(15%) saturate(1234%) hue-rotate(189deg) brightness(95%) contrast(89%)"
            }}
            onClick={() => {
              nextPage(limit);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CPagination;
